import { render, staticRenderFns } from "./ActivityLogs.vue?vue&type=template&id=622f51d3&scoped=true"
import script from "./ActivityLogs.vue?vue&type=script&lang=js"
export * from "./ActivityLogs.vue?vue&type=script&lang=js"
import style0 from "./ActivityLogs.vue?vue&type=style&index=0&id=622f51d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622f51d3",
  null
  
)

export default component.exports